import $ from 'jquery'
import { SimpleroManager, registerManager } from '~/common/extensions/dom_ready'
import SimpleroPusher from '~/common/helpers/simplero_pusher'
import { AjaxHelper } from '~/common/extensions/ajax_helpers'

class PusherWaiter extends SimpleroManager {
  constructor(elm, name, options) {
    super(elm, name)

    let left, left1, left2
    this.triggerCallback = this.triggerCallback.bind(this)
    this.onTimeout = this.onTimeout.bind(this)
    this.onSuccess = this.onSuccess.bind(this)
    this.onInterval = this.onInterval.bind(this)

    this.options = options != null ? options : {}
    this.channel =
      this.options.channel != null
        ? this.options.channel
        : this.elm.attr('data-channel')
    this.event =
      this.options.event != null
        ? this.options.event
        : this.elm.attr('data-event')
    this.token =
      this.options.token != null
        ? this.options.token
        : this.elm.attr('data-token')
    this.timeout =
      (left =
        this.options.timeout != null
          ? this.options.timeout
          : this.elm.data('timeout')) != null
        ? left
        : 5
    this.oneShot =
      (left1 =
        this.options.oneShot != null
          ? this.options.oneShot
          : this.elm.data('one-shot')) != null
        ? left1
        : false
    // Fetch cached events on page load (set to false if component renders completed state)
    this.fetchCached =
      (left2 =
        this.options.fetchCached != null
          ? this.options.fetchCached
          : this.elm.data('fetch-cached')) != null
        ? left2
        : true
    this.interval = Number(this.elm.data('interval'))

    if (this.interval > 0) {
      this.intervalTimer = setInterval(this.onInterval, this.interval * 1000)
    }

    this.timer = setTimeout(this.onTimeout, this.timeout * 1000)
    this.fired = false

    SimpleroPusher.bind(
      this.channel,
      this.event,
      this.onSuccess,
      this.fetchCached,
      this.token
    )
  }

  triggerCallback(callback, data) {
    if (this.options[callback] != null) {
      this.options[callback].call()
    }
    if (this.options.complete != null) {
      this.options.complete.call()
    }
    this.elm.trigger(`waiter:${callback}`, data)
    this.elm.trigger('waiter:complete', data)
    // Also dispatch as native CustomEvents so non-jQuery listeners (e.g. Stimulus
    // `data-action="waiter:success->..."`) can hear them. jQuery's .trigger() only
    // notifies jQuery handlers for custom event types.
    this.elm[0].dispatchEvent(
      new CustomEvent(`waiter:${callback}`, { detail: data, bubbles: true })
    )
    return this.elm[0].dispatchEvent(
      new CustomEvent('waiter:complete', { detail: data, bubbles: true })
    )
  }

  onTimeout() {
    if (this.intervalTimer != null) {
      clearInterval(this.intervalTimer)
      this.intervalTimer = null
    }

    this.timer = null
    return this.triggerCallback('timeout')
  }

  stopTimers() {
    if (this.timer != null) {
      clearTimeout(this.timer)
      this.timer = null
    }

    if (this.intervalTimer != null) {
      clearInterval(this.intervalTimer)
      this.intervalTimer = null
    }
  }

  onInterval() {
    SimpleroPusher.fetchEvents(
      this.channel,
      this.event,
      this.onSuccess,
      this.token
    )
  }

  onSuccess(data) {
    // The chat pane swaps its whole conversation on every click in the sidebar, and nothing
    // unbinds the waiter that left with it. Both the old element's waiter and the new one's are
    // still bound to the same user channel, so one push arrived twice and everything it appended
    // — the agent's closing message, the run's card — was drawn twice over.
    if (!this.elm[0]?.isConnected) {
      this.stopTimers()
      SimpleroPusher.unbind(this.channel, this.event, this.onSuccess)
      return
    }

    if (this.timer != null) {
      clearTimeout(this.timer)
      this.timer = null
    }

    if (this.intervalTimer != null) {
      clearInterval(this.intervalTimer)
      this.intervalTimer = null
    }

    const firstShot = !this.fired
    this.fired = true

    if (this.oneShot && !firstShot) {
      return
    }

    // Run any callbacks
    this.triggerCallback('success', data)

    if (this.event?.startsWith('simplero_pusher_ajax_update')) {
      AjaxHelper.doUpdate(data, this.elm)
      return
    }

    // If the wait block includes a data-url attribute, request that URL now
    if (this.elm.data('url') != null) {
      $.get(this.elm.data('url'), (data, _status, _xhr) =>
        AjaxHelper.doUpdate(data)
      )
    }

    // If the event payload includes a redirect_to attribute, redirect to that URL.
    // Respect any data-complete-url-override on the element (signup/billing processing pages
    // override the redirect target with their own follow-up URL).
    const redirectUrl =
      this.elm.data('complete-url-override') || data.redirect_to
    if (redirectUrl != null) {
      window.location.href = redirectUrl
    }

    if (data.reload != null) {
      window.location.reload()
    }

    if (data.refresh_table != null) {
      return AjaxHelper.doUpdate({ refresh_table: data.refresh_table })
    }

    if (data.notice != null) {
      AjaxHelper.doUpdate({ notice: data.notice })
    }
  }
}

$.fn.pusherWaiter = function (options) {
  return this.each(function () {
    return new PusherWaiter(this, 'PusherWaiter', options)
  })
}

registerManager(PusherWaiter, 'PusherWaiter', '[data-behavior~=wait]')
